import { OpenAPI } from "simplydo/interfaces";

export const persistentTokens = (api) => ({
  get(
    forType: string,
    forId: string,
    forEntity: string,
    success: (
      data: OpenAPI.GET<"/persistent-tokens/{for_type}/{for_id}/{for_entity}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/persistent-tokens/${forType}/${forId}/${forEntity}`,
      null,
      success,
      fail,
    );
  },
  create(
    data: { forType: string; forId: string; forEntity: string },
    success: (data: OpenAPI.POST<"/persistent-tokens">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("POST", "/persistent-tokens", data, success, fail);
  },
  delete(
    id: string,
    success: (
      data: OpenAPI.DELETE<"/persistent-tokens/{id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/persistent-tokens/${id}`,
      null,
      success,
      fail,
    );
  },
  invalidate(
    id: string,
    success: (
      data: OpenAPI.POST<"/persistent-tokens/{id}/invalidate">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/persistent-tokens/${id}/invalidate`,
      null,
      success,
      fail,
    );
  },
  getByToken(
    token: string,
    success: (
      data: OpenAPI.GET<"/persistent-tokens/redeem/{token}">["response"],
    ) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/persistent-tokens/redeem/${token}`,
      null,
      success,
      fail,
    );
  },
  redeem(
    token: string,
    success: (
      data: OpenAPI.POST<"/persistent-tokens/redeem/{token}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/persistent-tokens/redeem/${token}`,
      null,
      success,
      fail,
    );
  },
});
